/* global $ */
import React, { Component } from 'react';
import { config } from './config.js';
import {  Redirect} from 'react-router-dom'

class SSORedirectURL extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isNotFound: false
        }
    };

    componentWillMount(){
        let error = this.getParameterByName('error',this.props.location.search);
        console.log(error);
        if (!error) {
            let token = this.getParameterByName('access_token', this.props.location.hash);
            let expires_in = this.getParameterByName('expires_in', this.props.location.hash);
            let portalName = this.getParameterByName('state', this.props.location.hash);
            $.ajax({
                url: config.accountServiceUrl + '/accounts',
                method: 'GET',
                dataType: 'json',
                crossDomain: true,
                cache: false,
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", "Bearer " + token);
                },
                success: function (data) {
                    var accountId = data.items[0].id;
                    // console.log("Account ID: " + accountId);
                    sessionStorage.setItem('isLoggedOut', "false");
                    this.props.setAdmin(false);
                    $.ajax({
                        url: config.captivePortalServiceUrl + '/captive-portals?account-scope='+ config.accountServiceUrl + '/accounts/' +
                            accountId + '&name=' + portalName,
                        method: 'GET',
                        dataType: 'json',
                        crossDomain: true,
                        cache:false,
                        beforeSend: function(request){
                            request.setRequestHeader("Authorization", "Bearer " + token);
                        },
                        success: function(data) {
                            let exist = data.items.some( item => item['name'] === portalName );
                            if (data.items.size == 0 || !exist) {
                                $('.ui.error.message').text("Portal does not exist in account");
                                $('#loginForm').removeClass("success").addClass("error");
                            } else {
                              var portalId = data.items[0].id;
                              this.props.showApp(token, accountId, expires_in, true, portalId);
                            }
                            $.ajax({
                                url: config.cbuServiceUrl + '/customer/' + accountId + '/' + portalId + '/settings',
                                method: 'GET',
                                dataType: 'json',
                                crossDomain: true,
                                cache: false,
                                beforeSend: function(request) {
                                    request.setRequestHeader("Authorization", "Bearer " + token);
                                },
                                success: function(data) {
                                    this.props.setBusinessName(data.businessName);
                                    this.props.setVradiusServerId(data.vRadiusServerId);
                                    this.props.history.push('/');
                                }.bind(this),
                                error: function(xhr, status, err) {
                                    if (xhr.status === 404 ){
                                        this.setState({isNotFound: true});
                                        console.log(this.state.isNotFound);
                                    }
                                    if (xhr.status === 500) {
                                        $('.ui.error.message').text(xhr.responseJSON.message);
                                        $('#loginForm').removeClass("success").addClass("error");
                                    }
                                }.bind(this)
                            });
                          }.bind(this)
                        });
                }.bind(this)
            });
        }
    }

     getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    render() {
        var styles1 = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            mozTransform: 'translateX(-50%) translateY(-50%)',
            webkitTransform: 'translateX(-50%) translateY(-50%)',
            transform: 'translateX(-50%) translateY(-50%)',
        };

        if (this.state.isNotFound) {
            return (
              <div style={styles1}>
                <h2>Incorrect portal identifier</h2>
              </div>
            );
          }
        return (
            <div>
                { this.getParameterByName('error',this.props.location.search) &&
                    <div>
                <header id="loginHeader">
                    <div id="gradient"></div>
                    <a href="/">proximus</a>
                </header>
                <div style={{textAlign: 'center', height: '250px', lineHeight: '250px', backgroundColor: '#D4D4D5'}}>
                    <span style={{verticalAlign: 'middle', lineHeight: '50px', fontSize: '30px', display: 'inline-block'}}>{this.getParameterByName('error',this.props.location.search)}</span>
                </div>
                    </div>
                        }
            </div>
        );
    }
}
export default SSORedirectURL;



// WEBPACK FOOTER //
// ./src/SSORedirectURL.jsx